import Swal from "sweetalert2";
import { Col } from 'react-bootstrap';
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import renderRadioButtonField from '@/shared/components/form/RadioButton';
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel } from '@/shared/components/form/FormElements';

const EditSubscriptionPrice = (props) => {
    const [subscriptionPrice, setSubscriptionPrice] = useState();

    useEffect(() => {
        setSubscriptionPrice(props.subscriptionPrice)
    }, [props.subscriptionPrice]);

    const submitOrganizationUpdates = (subscriptionPrice) => {
        AdminInterface.instance.updateSubscriptionPrice(subscriptionPrice.plan_id, subscriptionPrice).then((response) => {
            if (response.data.status_code !== undefined && response.data.status_code != 200) {
                withReactContent(Swal).fire({
                    title: "Error",
                    html: response.data.detail,
                });
            } else {
                Swal.fire('Updated!', '', 'success')
                props.setListRequiresReload(true);
            }
        }).catch((error) => {
            withReactContent(Swal).fire({
                title: "Error",
                html: error.response?.data?.detail,
            });
        })
    }

    return (
        <Col md={12} lg={12}>
            <Card>
                <CardBody>
                    <CardTitleWrap>
                        <CardTitle>Edit Subscription Plan Price</CardTitle>
                    </CardTitleWrap>
                    <Form onSubmit={submitOrganizationUpdates} initialValues={subscriptionPrice}>
                        {({ handleSubmit, form }) => (
                            <FormContainer horizontal onSubmit={handleSubmit} disabled>
                                <FormGroup>
                                    <FormGroupLabel>Subscription Plan Id</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="plan_id" component="input" type="text" placeholder="Id" disabled />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Subscription Plan Name</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="product_name" component="input" type="text" placeholder="Subscription Plan Name" disabled />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Interval</FormGroupLabel>
                                    <FormGroupField>
                                        <Field disabled
                                            name="interval"
                                            component={renderRadioButtonField}
                                            label="Month"
                                            radioValue="month"
                                        />
                                        <Field disabled
                                            name="interval"
                                            component={renderRadioButtonField}
                                            label="Year"
                                            radioValue="year"
                                        />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Price</FormGroupLabel>
                                    <FormGroupField>
                                        <Field name="price" component="input" type="number" placeholder="Price (CAD)" />
                                    </FormGroupField>
                                </FormGroup>
                                <FormGroup>
                                    <FormGroupLabel>Is Active?</FormGroupLabel>
                                    <FormGroupField>
                                        <Field
                                            name="active"
                                            component={renderRadioButtonField}
                                            label="No"
                                            radioValue={false}
                                        />
                                        <Field
                                            name="active"
                                            component={renderRadioButtonField}
                                            label="Yes"
                                            radioValue={true}
                                        />
                                    </FormGroupField>
                                </FormGroup>
                                <FormButtonToolbar>
                                    <Button variant="primary" type="submit">Submit</Button>
                                    <Button variant="secondary" type="button" onClick={() => {
                                        props.setEditSubscriptionPrice(null);
                                    }}>Cancel</Button>
                                </FormButtonToolbar>
                            </FormContainer>)}
                    </Form>
                </CardBody>
            </Card>
        </Col>
    );
};

export default EditSubscriptionPrice;